<template>
  <div>
    <v-card>
      <v-card>
        <v-toolbar>
          <v-btn icon @click="closeProduct">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{
              $route.name === "addproduct"
              ? "Добавить продукт:"
              : "Редактировать продукт:"
            }}
            {{ itemProduct.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn outlined @click="saveProduct">
            <v-icon left>save</v-icon>Записать
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- <v-layout wrap> -->
          <!-- первый столб -->
          <div xs12 sm12 md12>
            <v-text-field v-model="itemProduct.name" label="Название" :error-messages="!itemProduct.name ? 'Поле должно быть заполнено' : undefined
              " />
            <v-text-field v-model="itemProduct.name_note" label="Название (примечание)"></v-text-field>
            <v-select v-model="itemProduct.bank" :items="product.banks" label="Банк" item-text="name" item-value="id"
              :error-messages="!itemProduct.bank ? 'Поле должно быть заполнено' : undefined
                ">
            </v-select>
            <v-text-field v-model="itemProduct.bank_note" label="Банк (примечание):"></v-text-field>
            <v-select v-model="product.purchasesVal" :items="product.purchases" label="Виды закупок" item-text="name"
              item-value="id" chips multiple :error-messages="product.purchasesVal && product.purchasesVal.length > 0
                  ? undefined
                  : 'Поле должно быть заполнено'
                "></v-select>
            <v-textarea v-model="itemProduct.purchase_note" label="Виды закупок (примечание):"></v-textarea>
            <Website v-if="itemProduct && itemProduct.bank" :sortList="getBankWebsite(product.banks, itemProduct.bank)"
              v-model="itemProduct.website" />
            <v-select v-model="product.gar_polz_zaksVal" :items="product.gar_polz_zaks"
              label="Гарантия в пользу заказчика" item-text="name" item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.gar_polz_zak_note" label="Гарантия в пользу заказчика (примечание):">
            </v-textarea>

            <v-select v-model="product.your_situationsVal" :items="product.your_situations" label="Ситуация у клиента"
              item-text="name" item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.your_situation_note" label="Ситуация у клиента (примечание):"></v-textarea>

            <SituationsWithComments />

            <v-select v-model="product.guaranteesVal" :items="product.guarantees" label="Виды гарантий:" item-text="name"
              item-value="id" chips multiple :error-messages="product.guaranteesVal && product.guaranteesVal.length > 0
                  ? undefined
                  : 'Поле должно быть заполнено'
                "></v-select>
            <v-textarea v-model="itemProduct.guarantee_note" label="Виды гарантий (примечание):"></v-textarea>
            <v-select v-model="product.requestsVal" :items="product.requests" label="Способы направления заявки в банк:"
              item-text="name" item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.request_note" label="Способы направления заявки в банк (примечание):">
            </v-textarea>
            <v-select v-model="product.principalsVal" :items="product.principals" label="Виды принципалов:"
              item-text="name" item-value="id" chips multiple :error-messages="product.principalsVal && product.principalsVal.length > 0
                  ? undefined
                  : 'Поле должно быть заполнено'
                "></v-select>
            <v-textarea v-model="itemProduct.principal_note" label="Виды принципалов (примечание):"></v-textarea>
            <v-select v-model="product.accountsVal" :items="product.accounts" label="Расчетный счет:" item-text="name"
              item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.account_note" label="Расчетный счет (примечание):"></v-textarea>
            <v-select v-model="product.bailsVal" :items="product.bails" label="Виды обеспечения:" item-text="name"
              item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.bail_note" label="Виды обеспечения  (примечание):"></v-textarea>
            <v-text-field v-model="itemProduct.mindays" label="Мин. срок гарантии, дней:"></v-text-field>
            <v-textarea v-model="itemProduct.mindays_note" label="Мин. срок гарантии, дней  (примечание):"></v-textarea>
            <v-text-field v-model="itemProduct.maxdays" label="Макс. срок гарантии, дней:"></v-text-field>
            <v-textarea v-model="itemProduct.maxdays_note" label="Макс. срок гарантии, дней (примечание):"></v-textarea>
            <v-text-field v-model="itemProduct.minsum" label="Мин. сумма по одной гарантии на Принципала:">
            </v-text-field>
            <v-textarea v-model="itemProduct.minsum_note"
              label="Мин. сумма по одной гарантии на Принципала  (примечание):"></v-textarea>

            <v-textarea v-model="itemProduct.maxsum" label="Макс. сумма по одной гарантии на Принципала"></v-textarea>
            <v-textarea v-model="itemProduct.maxsum_note" label="Макс. сумма гарантии (примечание):"></v-textarea>
            <v-text-field v-model="itemProduct.allmaxsums" label="Сумма по всем гарантиям Принципала в банке:">
            </v-text-field>
            <v-textarea v-model="itemProduct.allmaxsums_note"
              label="Сумма по всем гарантиям Принципала в банке (примечание):"></v-textarea>

            <v-select v-model="product.tariffsVal" :items="product.tariffs" label="Тариф" item-text="name" item-value="id"
              chips multiple :error-messages="product.tariffsVal && product.tariffsVal.length > 0
                  ? undefined
                  : 'Поле должно быть заполнено'
                "></v-select>
            <v-textarea v-model="itemProduct.tariff_note" label="Тариф (примечание):"></v-textarea>

            <v-select v-model="itemProduct.limit" :items="product.limits" label="Установление лимита на Принципала:"
              item-text="name" item-value="id" chips :error-messages="!itemProduct.limit ? 'Поле должно быть заполнено' : undefined
                "></v-select>
            <v-textarea v-model="itemProduct.limit_note" label="Установление лимита на Принципала (примечание):">
            </v-textarea>

            <v-checkbox v-model="itemProduct.charge" label="Условие о беccпорном списании"></v-checkbox>
            <v-text-field v-model="itemProduct.charge_note" label="Условие о беccпорном списании (примечание):">
            </v-text-field>

            <v-checkbox v-model="itemProduct.prepaid" label="Условие о выплате аванса"></v-checkbox>
            <v-text-field v-model="itemProduct.prepaid_note" label="Условие о выплате аванса (примечание):">
            </v-text-field>

            <v-checkbox v-model="itemProduct.form" label="Гарантия по форме заказчика"></v-checkbox>
            <v-text-field v-model="itemProduct.form_note" label="Гарантия по форме заказчика (примечание):">
            </v-text-field>

            <v-select v-model="product.othersVal" :items="product.others" label="Прочие условия:" item-text="name"
              item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.other_note" label="Прочие условия (примечание):"></v-textarea>

            <v-select v-model="itemProduct.reloadbg" :items="product.reloadbgs" label="Перевыпуск БГ" item-text="name"
              item-value="id"></v-select>
            <v-textarea v-model="itemProduct.reloadbg_note" label="Перевыпуск БГ (примечание)"></v-textarea>

            <v-select v-model="product.lifesVal" :items="product.lifes" label="Срок существования клиента, мес.:"
              item-text="name" item-value="id" chips multiple :error-messages="product.lifesVal && product.lifesVal.length > 0 ? undefined : 'Поле должно быть заполнено'
                "></v-select>
            <v-textarea v-model="itemProduct.life_note" label="Срок существования клиента, мес. (примечание):">
            </v-textarea>

            <v-select v-model="product.practicesVal" :items="product.practices"
              label="Опыт исполнения контрактов и/или договоров, шт.:" item-text="name" item-value="id" chips multiple
              :error-messages="product.practicesVal && product.practicesVal.length > 0
                  ? undefined
                  : 'Поле должно быть заполнено'
                ">
            </v-select>
            <v-textarea v-model="itemProduct.practice_note" label="Опыт исполнения контрактов (примечание):">
            </v-textarea>

            <v-textarea v-model="itemProduct.stopfactor" label="Иные требования к принципалу и Стоп-факторы:">
            </v-textarea>
            <v-textarea v-model="itemProduct.stopfactor_note" label="Стоп-факторы (примечание):"></v-textarea>

            <v-select v-model="itemProduct.preview" :items="product.previews" label="Предварительное рассмотрение:"
              item-text="name" item-value="id" chips></v-select>
            <v-textarea v-model="itemProduct.preview_note" label="Предварительное рассмотрение (примечание):">
            </v-textarea>

            <v-select v-model="product.packetsVal" :items="product.packets"
              label="Пакет документов для получения гарантии:" item-text="name" item-value="id" chips multiple
              :error-messages="product.packetsVal && product.packetsVal.length > 0
                  ? undefined
                  : 'Поле должно быть заполнено'
                ">
            </v-select>
            <v-textarea v-model="itemProduct.packet_note" label="Пакет документов (примечание):"></v-textarea>

            <v-select v-model="itemProduct.usn" :items="product.usns"
              label="Промежуточная управленческая отчетность ф.1 и ф.2 при УСН:" item-text="name" item-value="id" chips
              :error-messages="!itemProduct.usn ? 'Поле должно быть заполнено' : undefined
                ">
            </v-select>
            <v-textarea v-model="itemProduct.usn_note" label="Отчетность при УСН (примечание):"></v-textarea>

            <v-select v-model="product.fnssVal" :items="product.fnss" label="Промежуточная отчетность с отметкой ФНС:"
              item-text="name" item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.fns_note" label="Промежуточная отчетность (примечание):"></v-textarea>

            <v-select v-model="product.thirdsVal" :items="product.thirds" label="Документы от сторонних организаций:"
              item-text="name" item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.third_note" label="Документы от сторонних организаций (примечание):">
            </v-textarea>

            <v-select v-model="product.methodsVal" :items="product.methods"
              label="Порядок подачи заявки, объем письма и использование файлообменников:" item-text="name"
              item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.method_note" label="Порядок подачи заявки (примечание):"></v-textarea>

            <v-select v-model="product.timesVal" :items="product.times" label="Срок рассмотрения заявки:" item-text="name"
              item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.time_note" label="Срок рассмотрения заявки (примечание):"></v-textarea>

            <v-select v-model="product.papersVal" :items="product.papers"
              label="Порядок направления клиенту гарантии на бумаге:" item-text="name" item-value="id" chips multiple>
            </v-select>
            <v-textarea v-model="itemProduct.paper_note"
              label="Порядок направления клиенту гарантии на бумаге  (примечание):"></v-textarea>

            <v-select v-model="itemProduct.osob" :items="product.osobs"
              label="Особенности сотрудничества с банком-партнером:" item-text="name" item-value="id"></v-select>
            <v-textarea v-model="itemProduct.osob_note"
              label="Особенности сотрудничества с банком-партнером (примечание):"></v-textarea>

            <WorkWhitAgent :itemProduct="itemProduct" :product="product" @valid="checkValidToWrokAgentFee" />

            <v-select v-model="product.edosVal" :items="product.edos" label="ЭДО с агентом:" item-text="name"
              item-value="id" chips multiple></v-select>
            <v-textarea v-model="itemProduct.edo_note" label="ЭДО с агентом (примечание):"></v-textarea>

            <v-select v-model="itemProduct.active" :items="activate" item-text="label" item-value="value" label="Активно:"
              :error-messages="itemProduct.active === undefined ? 'Поле должно быть заполнено' : undefined"></v-select>
          </div>
          <!-- </v-layout> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeProduct" outlined>Отмена (закрыть)</v-btn>
          <v-btn @click="saveProduct" outlined>Записать</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import SituationsWithComments from "./situationWithCommentTable.vue";
import Website from "./components/website.vue";
import WorkWhitAgent from "./components/WorkWhitAgent.vue";

export default {
  components: {
    SituationsWithComments: SituationsWithComments,
    Website,
    WorkWhitAgent,
  },
  data() {
    return {
      activate: [
        { label: "да", value: 1 },
        { label: "нет", value: 0 },
      ],
      item: null,
      itemProduct: {
        name: "",
        active: false,
      },
      product: [],
      dessertsSit: [],
      headersSit: [
        {
          text: "Ситуация у клиента",
          align: "left",
          sortable: true,
          value: "sit_id",
        },
        {
          text: "Описание",
          align: "left",
          sortable: true,
          value: "note",
        },
        { text: "Действия", align: "center", value: "name", sortable: false },
      ],
    };
  },
  mounted() {
    if (this.$route.name === "addproduct") {
      this.itemProduct = {};
      this.product = this.$store.getters.getProductData;
      this.setTitle(`Добавить продукт`);
      return;
    }

    if (this.$route.name === "editproduct") {
      if (
        !this.$store.getters.getProductCS ||
        !this.$store.getters.getProductCS.name ||
        !this.$store.getters.getProductData
      ) {
        this.$router.push("/calcsettings");
        return;
      }

      this.itemProduct = this.$store.getters.getProductCS;
      this.product = this.$store.getters.getProductData;
      this.setTitle(`Редактировать продукт: ${this.itemProduct.name}`);
    }
  },
  methods: {
    closeProduct() {
      this.$store.commit("SET_PRODUCTDATA", {});
      this.$router.push({ name: "calcsettings" });
    },
    checkValidToWrokAgentFee(val) {
      this.standartAgents = val;
    },
    async saveProduct() {
      if (
        !this.itemProduct.name ||
        !this.itemProduct.bank ||
        !(this.product.purchasesVal && this.product.purchasesVal.length > 0) ||
        !(this.product.guaranteesVal && this.product.guaranteesVal.length > 0) ||
        !(this.product.principalsVal && this.product.principalsVal.length > 0) ||
        !(this.product.tariffsVal && this.product.tariffsVal.length > 0) ||
        !this.itemProduct.limit ||
        !(this.product.lifesVal && this.product.lifesVal.length > 0) ||
        !(this.product.practicesVal && this.product.practicesVal.length > 0) ||
        !(this.product.packetsVal && this.product.packetsVal.length > 0) ||
        !this.itemProduct.usn ||
        this.itemProduct.active === undefined
      ) {
        Swal.fire({
          icon: "error",
          title: "Ошибка",
          text: "Не все обязательные поля заполнены",
        });
        return;
      }

      const success = () => {
        this.$store.commit("SET_CURRENT_PRODUCTCS", {});
        Swal.fire({
          icon: "success",
          title: "Данные успешно сохранились",
          text: "Продукт сохранился",
        });
      };
      const error = (e) => {
        Swal.fire({
          icon: "error",
          title: "Данные не сохранились",
          text: "Продукт не сохранился",
        });

        alert(e);
      };
      const formArr = Object.assign({}, this.itemProduct);
      const varNameArr = [
        "tariff",
        "accreditation",
        "principal",
        "request",
        "bail",
        "account",
        "paper",
        "other",
        "life",
        "practice",
        "fns",
        "third",
        "edo",
        "purchase",
        "guarantee",
        "packet",
        "method",
        "time",
        "agentsfee",
        "gar_polz_zak",
        "your_situation",
      ];
      for (let i = 0; i < varNameArr.length; i++) {
        if (this.product[varNameArr[i] + "sVal"] != null) {
          formArr[varNameArr[i]] = this.product[varNameArr[i] + "sVal"].join();
        }
      }

      if (this.$route.name === "addproduct") {
        try {
          //saved workAgent sale list
          await this.$store.dispatch("updateSaleList");

          await this.$store.dispatch("SaveNewProductCS", formArr);
          success();
        } catch (e) {
          error(e);
        }
      }

      if (this.$route.name === "editproduct") {
        try {
          //saved workAgent sale list
          await this.$store.dispatch("updateSaleList");

          await this.$store.dispatch("updateProductCS", formArr);
          success();
        } catch (e) {
          error(e);
        }
      }

      this.$router.push({ name: "calcsettings" });
    },
    AddSit() { },
  },
};
</script>

<style lang="scss"></style>
